import { PageHeader } from "../components/PageHeader";
import { useSiteContent, resolveImageUrl } from "../context/ContentContext";
import Icon from "../components/Icon";

export default function Compliance() {
  const { content } = useSiteContent();
  const { compliance_blocks, images, compliance_page } = content;
  const pageCopy = compliance_page || {};

  return (
    <>
      <PageHeader
        eyebrow={pageCopy.header_eyebrow}
        title={
          <>
            {pageCopy.header_title_part1} <span className="theme-text-accent">{pageCopy.header_title_highlight}</span>
            {pageCopy.header_title_part2}
          </>
        }
        intro={pageCopy.header_intro}
      />

      <section className="section-pad">
        <div className="container-x grid lg:grid-cols-2 gap-12">
          <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl">
            <img src={resolveImageUrl(images.vault)} alt="Secure vault" className="w-full h-full object-cover" />
          </div>
          <div className="grid sm:grid-cols-2 gap-5 self-start">
            {compliance_blocks.map((b, i) => (
              <div key={i} className="card-soft p-6" data-testid={`compliance-block-${i}`}>
                <div className="w-12 h-12 rounded-2xl theme-icon-chip flex items-center justify-center mb-5">
                  <Icon name={b.icon} className="w-5 h-5" />
                </div>
                <h3 className="font-display text-lg font-bold theme-text-primary mb-2">{b.title}</h3>
                <p className="theme-text-secondary text-sm leading-relaxed">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="theme-bg-secondary py-16">
        <div className="container-x">
          <div className="rounded-3xl theme-surface p-8 md:p-12">
            <div className="eyebrow mb-3">{pageCopy.note_eyebrow}</div>
            <p className="theme-text-secondary leading-relaxed">
              {pageCopy.note_body}
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
